function canUploadImage(filename) {
  const allowedExtensions = ["jpg", "png", "webp", "jpeg", 'pdf', 'xlsx'];
  const extension = filename?.split('.').pop().toLowerCase();
  return allowedExtensions.includes(extension);
}

export { canUploadImage }